import { Dto } from "./dto";

export class DtoGroup {
  /**
 * The name of the item
 */
  name: string;

  /**
   * The identifier of the item
   */
  id: number;

  /**
   * The description of the item
   */
  description: string;

  /**
   * Indicates whether the item represents a business unit
   */
  isBu: boolean;

  /**
   * Indicates whether the item is currently collapsed
   */
  isCollapsed: boolean;

  /**
   * The list of DTOs associated with the item
   */
  dtoList: Dto[];
}
